import type { ReactNode } from 'react';

export type KeyValueItem = { k: ReactNode; v: ReactNode; mono?: boolean; key?: string };

/** Pares rótulo/valor (`.kv`) dos painéis de detalhe e das conexões. `flush` tira o recuo. */
export function KeyValueList({ items, flush = false }: { items: KeyValueItem[]; flush?: boolean }) {
  return (
    <>
      {items.map((it, i) => (
        <div className="kv" key={it.key ?? i} style={flush ? { paddingLeft: 0 } : undefined}>
          <span>{it.k}</span>
          <span className={it.mono ? 'mono' : undefined}>{it.v}</span>
        </div>
      ))}
    </>
  );
}
